<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <custom-popup
        v-model="dialog"
        :cons="cons"
        max-width="640"
        @close="$emit('close')"
      >
        <v-card class="pa-4" flat>
          <custom-tabs v-model="tabs" :tab-items="itemtabs" grow>
            <template v-slot:helpinfo="{ tab }">
              <help-info
                v-if="tab && tab.value && tab.text"
                :element-name="`${serviceName}-${componentName}-${tab.value}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${tab.text}`"
              />
            </template>
            <template v-slot:staticItems>
              <v-tab-item>
                <div class="pa-4">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="customName"
                      append-icon="mdi-text"
                      clear-icon="mdi-close-circle-outline"
                      class="contentinfo"
                      clearable
                      dense
                      hide-details
                      :label="$t('category_name')"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-customName`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('category_name')"
                    />
                  </div>

                  <pic-selector
                    :edit-img="false"
                    :edit-name="false"
                    :field.sync="customIcon"
                    :default-cat-name="$t('TITLES.ADMIN_CATEGORY')"
                    one-pic
                    single
                  />
                </div>
              </v-tab-item>

              <v-tab-item>
                <v-card-title
                  v-if="breadcrumbs[0] && breadcrumbs[0].text !== '/'"
                >
                  <v-btn
                    v-if="breadcrumbs[0].text !== '/'"
                    icon
                    @click="
                      handleBreadClick(breadcrumbs[breadcrumbs.length - 1])
                    "
                  >
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>

                  <!--      <v-breadcrumbs-->
                  <v-breadcrumbs :items="breadcrumbs">
                    <template v-slot:item="{ item }">
                      <v-breadcrumbs-item
                        class="cursor-pointer"
                        @click="handleBreadClick(item)"
                      >
                        {{ item.text }}
                      </v-breadcrumbs-item>
                    </template>
                  </v-breadcrumbs>
                </v-card-title>

                <v-card-text v-if="computedCategory.length">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="search"
                      class="rounded-lg contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      hide-details
                      :label="$t('search')"
                      outlined
                    /><help-info
                      :element-name="`${serviceName}-${componentName}-search`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('search')"
                    />
                  </div>
                </v-card-text>

                <v-card-text class="pa-0">
                  <v-chip-group>
                    <v-chip v-for="(item, i) in checkedItems" :key="i">{{
                      item.title
                    }}</v-chip>
                  </v-chip-group>
                </v-card-text>

                <v-list-item>
                  <v-list-item-action>
                    <v-simple-checkbox
                      :color="selectAll ? 'primary' : ''"
                      :indeterminate="!selectAll && selectSome"
                      :value="selectAllValue"
                      @click="clickAll()"
                    />
                  </v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title>
                      <b>{{ $t("select") }}</b>
                      <template v-if="!!breadcrumbs && !!breadcrumbs.length">
                        {{
                          breadcrumbs.length === 1 &&
                          breadcrumbs[0].text === "/"
                            ? $t("whole_categories")
                            : !computedCategory.length
                            ? breadcrumbs.at(-1).text
                            : `${$t("all")} (${breadcrumbs.at(-1).text})`
                        }}
                      </template>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-for="(cat, i) in computedCategory"
                  :key="i"
                  dense
                  @click="selectCat(cat, i)"
                >
                  <v-list-item-action>
                    <v-checkbox
                      v-model="cat.checked"
                      :indeterminate="!!cat.state ? cat.state !== 'all' : false"
                      hide-details
                      @click.stop="checkParent(cat)"
                    />
                  </v-list-item-action>

                  <v-list-item-avatar>
                    <v-img :src="cat.icon" />
                  </v-list-item-avatar>
                  <v-list-item-content class="px-2">
                    <v-list-item-title v-text="cat.title" />
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      v-show="
                        !!categories.filter((item) => item.parent_id === cat.id)
                          .length
                      "
                      icon
                    >
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-tab-item>
            </template>
          </custom-tabs>
        </v-card>
      </custom-popup>
    </template>
  </help-info-wrapper>
</template>

<script>
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";
import { debounce } from "@/main";

const categoryWorker = new Worker("js/categoryWorker.js");

export default {
  name: "categoryPicker",

  components: { PicSelector },

  props: {
    value: Boolean,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "category-picker",
      // itemtabs: [
      //   { text: "افزودن دسته جدید", value: "add-new-category", icon: "" },
      //   {
      //     text: "انتخاب دسته پیشفرض",
      //     value: "choice-default-category",
      //     icon: "",
      //   },
      // ],
      categories: [],
      parent_id: null,
      loading: false,
      breadcrumbs: [
        {
          text: "/",
          disabled: true,
          href: "",
        },
      ],

      tabs: 0,
      customName: "",
      customIcon: "",
      search: "",
    };
  },

  computed: {
    itemtabs() {
      return [
        { text: this.$t("addCategory"), value: "add-new-category", icon: "" },
        {
          text: this.$t("select_default_category"),
          value: "choice-default-category",
          icon: "",
        },
      ];
    },
    cons() {
      return {
        title: this.$t("add_select_category"),
        buttons: [
          // {type: 'submit', disabled: () => !this.canSelect, handler: () => this.submitSelect()}
          { type: "submit", handler: () => this.submitSelect() },
        ],
      };
    },
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedCategory() {
      let keys = this.categories;

      if (this.breadcrumbs[0]?.text === "/") return keys;
      else {
        this.breadcrumbs
          .map((item) => item.href)
          .forEach((item) => {
            keys = keys[item]["children"];
          });

        return keys;
      }

      // return this.search?.length > 2
      //   ? this.allCats.filter(item => !this.search || item.title.indexOf(this.search) >= 0)
      //   : this.allCats.filter(item => item.parent_id === this.parent_id)
    },
    // canSelect() {
    //   return !!this.parent_id || (!!this.customName && this.customName.length >= 3)
    // },
    selectAllValue() {
      return this.selectAll || this.selectSome;
    },
    selectAll() {
      return this.computedCategory.every((item) => !!item.checked);
    },
    selectSome() {
      return this.computedCategory.some((item) => !!item.checked);
    },
    checkedItems() {
      return this.categories.filter((item) => !!item.checked);
    },
  },

  watch: {
    value(val) {
      if (val) this.fetchCategories();
    },
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    fetchCategories() {
      this.loading = true;

      this.$api
        .get(this.$qrApi + "/admin/category")
        .then(({ data }) => {
          const categories = data.data.map((item) => ({
            ...item,
            checked: false,
          }));

          // Step 1: Create a map of categories by their IDs
          const categoryMap = {};
          categories.forEach((category) => {
            categoryMap[category.id] = { ...category, children: [] };
          });

          // Step 2: Recursive function to build the tree
          function buildTree(category) {
            // Find and assign children to the current category
            category.children = categories
              .filter((cat) => cat.parent_id === category.id)
              .map((cat) => {
                // Create a copy of the child to avoid mutating the original category objects
                const child = { ...categoryMap[cat.id] };
                // Recursively build the tree for each child
                buildTree(child);
                return child;
              });
          }

          // Step 3: Collect top-level categories and build the tree
          const topLevelCategories = [];
          categories.forEach((category) => {
            if (category.parent_id === null) {
              const topLevelCategory = { ...categoryMap[category.id] };
              buildTree(topLevelCategory);
              topLevelCategories.push(topLevelCategory);
            }
          });

          this.categories = topLevelCategories;
        })
        .catch(({ response }) =>
          console.log("failed to get categories data: ", response)
        )
        .finally(() => (this.loading = false));
    },
    selectCat(cat, index) {
      if (!cat.children?.length) {
        this.checkParent();
        return;
      }

      const _this = this;
      let arr = [];

      function getParent(child) {
        arr.push(child);

        if (child.parent_id != null) {
          getParent(
            _this.categories.find((item) => item.id === child.parent_id)
          );
        }
      }

      if (this.search?.length > 2) {
        getParent(cat);
        let bread = [];

        arr.reverse().forEach((item) => {
          bread.push({
            text: item.title,
            disabled: false,
            href: "",
            id: item.parent_id,
          });
        });

        this.breadcrumbs = bread;
      } else {
        if (this.breadcrumbs[0].text === "/") this.breadcrumbs.pop();

        this.$nextTick(() => {
          this.breadcrumbs.push({
            text: cat.title,
            disabled: false,
            href: index,
            id: cat.parent_id,
          });
        });
      }

      this.parent_id = cat.id;
      this.search = "";
    },
    handleBreadClick(item) {
      this.parent_id = item.id;
      let bread = this.breadcrumbs;
      let index = bread.findIndex((b) => b.id === item.id);
      do {
        bread.pop();
      } while (bread.length >= index + 1);
      this.breadcrumbs = bread;
      this.$nextTick(() => {
        if (!this.breadcrumbs.length)
          this.breadcrumbs.push({
            text: "/",
            disabled: true,
            href: "",
          });
      });
    },
    submitSelect() {
      let arr = [];

      if (this.tabs === 0) {
        arr = [
          {
            status: "active",
            source_id: null,
            name: this.customName,
            picture: this.customIcon,
            products: [],
            children: [],
          },
        ];

        this.$emit("submit", arr);
      } else {
        if (window.Worker) {
          categoryWorker.postMessage(this.categories);
          categoryWorker.onmessage = (e) => {
            this.$emit("submit", e.data);
          };
        } else this.$toast.error(this.$t("error_selected_category"));
      }

      this.breadcrumbs = [
        {
          text: "/",
          disabled: false,
          href: "",
        },
      ];
      this.parent_id = null;
      this.search = "";

      this.$emit("close");
    },
    clickAll(input) {
      this.$nextTick(() => {
        const s = this.selectAll;

        function checkChildren(children) {
          children.forEach((item) => {
            item.checked = !s;

            if (!!item?.children?.length) checkChildren(item.children);
          });
        }

        checkChildren(input ?? this.computedCategory);
        !input && this.checkParent();
      });
      this.$forceUpdate();
    },
    checkParent(cat) {
      debounce(() => {
        !!cat && this.clickAll(cat.children);

        const s = this.selectAll;

        let keys = JSON.parse(JSON.stringify(this.categories));
        let breads = JSON.parse(JSON.stringify(this.breadcrumbs));
        breads.pop();
        breads
          .map((item) => item.href)
          .forEach((item) => {
            keys = keys[item]["children"];
          });

        let id = this.computedCategory[0].parent_id;
        let index = keys.findIndex((item) => item.id === id);
        !!keys[index] && (keys[index].checked = s);

        const parent = keys[index];
        if (!parent) return;

        let { every, some } = setChecked(this.computedCategory);
        let all = [];

        flattenArray(this.categories);
        const allCats = all.flat();
        let catIndex = allCats.findIndex((item) => item.id === parent.id);

        allCats[catIndex].state = every ? "all" : some ? "some" : false;
        allCats[catIndex].checked = every;

        function setChecked(children) {
          let every = children.every((item) => item.checked);
          let some = children.some((item) => item.checked);

          return {
            every,
            some,
          };
        }

        function flattenArray(arr) {
          arr.forEach((children, index) => {
            all.push(children);

            if (arr[index].children?.length) flattenArray(arr[index].children);
          });
        }
      }, 300);
    },
  },
};
</script>
